import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

const typography = {
  objektiv: 'objektiv-mk1, sans-serif',
  modern20: 'Modern20, sans-serif',
};

injectGlobal(`
  @font-face {
    font-family: 'Modern20';
    src: local('Modern20'),
      url('./fonts/MOD20.woff') format('woff');
  }
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${typography.objektiv};
  }
  h1, h2, h3 {
    font-family: ${typography.modern20};
  }
  ${
    typography.objektiv &&
    `
      .text-motivia {
        font-family: ${typography.objektiv}
      }
    `
  }
  a {
    color: ${colors.color1};
    transition: all .3s ease-out;
    &:hover {
      text-decoration: none;
      color: ${colors.color2Darkest};
      transition: all .3s ease-out;
    }
  }

  .GlobalSection_heading {
    text-align: center;
    margin: 0 0 30px 0;
  }

  strong, b, bold {
    font-weight: 700;
  }
`);

export default typography;



// WEBPACK FOOTER //
// ./src/styles/typography.js